import React from "react";
import { ActionCable } from "react-actioncable-provider";
import { connect } from "react-redux";

import { updateUploadPlanStatus } from "../actions/plan";

function PlanUploadChannel(props) {
  function channelListener(data) {
    console.log(data)
    props.updateUploadPlanStatus(data.type, data.details);
  }

  return <ActionCable channel={{ channel: "PlanUploadChannel" }} onReceived={channelListener} />;
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateUploadPlanStatus: (status, details) => dispatch(updateUploadPlanStatus(status, details)),
  };
};

export default connect(undefined, mapDispatchToProps)(PlanUploadChannel);



// WEBPACK FOOTER //
// ./src/components/plan_upload_channel.js